import { AccountInfo } from './RequestModel';

export interface VerificationResponse {
  unblockTime?: string;
  accessToken: string;
}

export const initVerificationResponse = () => {
  const init: VerificationResponse = { accessToken: '' };
  return init;
};

export interface SuccessResponse {
  status: boolean;
}

export const initSuccessResponse = () => {
  const init: SuccessResponse = { status: false };
  return init;
};

export interface AccountInfoResponse extends AccountInfo {
  registrationNumber: string;
  policyNumber: string;
  productType: string;
  loanGroup: string;
}

export interface AccountListResponse {
  accessToken: string;
  accounts: AccountInfoResponse[];
}

export const initAccountsResponse = () => {
  const init: AccountListResponse = { accessToken: '', accounts: [] };
  return init;
};

export interface LoanDetailResponse {
  orgAmount: string;
  term: string;
  loanInterestRate: string;
  productType: string;
  registeredNumber: string;
  dueDate: string;
  paymentAmount: string;
  principal: string;
  unearnedInterest: string;
}
